/**
 * Custom hook for CreateNewActionPlan logic
 */

import { useCallback } from 'react';

/**
 * Hook to manage CreateNewActionPlan form handlers
 */
export const useCreateNewActionPlan = (
  onCreated?: (created: any) => void,
  onCancel?: () => void
) => {
  /**
   * Handle form submission
   */
  const handleSubmit = useCallback(
    (payload: any) => {
      console.log('CreateActionPlanForm submit', payload);
      // Bubble up to parent container so it can navigate back to dashboard and select the created item
      if (onCreated) {
        try {
          onCreated(payload);
        } catch (e) {
          console.error('onCreated handler failed', e);
        }
      }
    },
    [onCreated]
  );

  /**
   * Handle form cancellation
   */
  const handleCancel = useCallback(() => {
    console.log('CreateActionPlanForm cancel');
    // Navigate back to dashboard when cancel is clicked
    if (onCancel) {
      try {
        onCancel();
      } catch (e) {
        console.error('onCancel handler failed', e);
      }
    }
  }, [onCancel]);

  return {
    handleSubmit,
    handleCancel,
  };
};
